import { createElement } from 'react';
import { Box } from '@alifd/next';
const EmptyBlock = () => {
    return (createElement(Box, { direction: 'column', align: 'center', justify: 'center', style: { width: '100%', height: '100%' } },
        createElement("img", { alt: "data empty", src: "//img.alicdn.com/tfs/TB1_yJXFkL0gK0jSZFAXXcA9pXa-1112-758.png", style: { width: '20%', height: '15%' } }),
        createElement(Box, { direction: 'column', align: 'center', justify: 'center', style: {
                width: '100%',
                fontSize: '24px',
                lineHeight: 1.5,
                color: '#999'
            } }, "\u6570\u636E\u4E3A\u7A7A")));
};
export default EmptyBlock;
